import { render, staticRenderFns } from "./OrderStowage.vue?vue&type=template&id=660ee319&"
import script from "./OrderStowage.vue?vue&type=script&lang=js&"
export * from "./OrderStowage.vue?vue&type=script&lang=js&"
import style0 from "./OrderStowage.vue?vue&type=style&index=0&id=660ee319&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports